











































import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import { FullNormalFormData, AcoFormData, IdentityOptionList, IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';
import ErrorTips from '../error-tips/index.vue';
import IdentityCommonTiktokList from '../common-tiktok-list/index.vue';
import IdentityTiktokPostAuthorizeButton from '../tiktok-post-authorize/button.vue';

type ListData = {
  list: IdentityOptionList[] | undefined;
  page: number;
  hasMore: boolean;
  cursor: number;
};

const name = 'ttam-tag-identity-post-authorize';
export default defineComponent({
  name,
  components: {
    ErrorTips,
    TtamIdentityCommonTiktokList: IdentityCommonTiktokList,
    TtamIdentityTiktokPostAuthorizeButton: IdentityTiktokPostAuthorizeButton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    listData: {
      type: Object as PropType<ListData>,
      default: () => ({
        list: [],
        page: 1,
        hasMore: true,
        cursor: 0,
      }),
    },
  },
  setup(props, { emit }) {
    const { creativeData, listData } = toRefs(props);

    const curIdentityId = computed(() => creativeData.value?.identityId || '');
    const curIdentityData = computed(() => creativeData.value?.identityData || {});

    const list = computed(() => listData.value?.list || []);
    const isListEmpty = computed(() => list.value?.length === 0);
    const isShowError = computed(() => !listData.value?.list);

    const onChange = data => {
      emit('change', data);
    };

    const refresh = () => {
      emit('refresh');
    };

    const onAddAuthorization = () => {
      emit('add-authorization');
    };

    return {
      name,
      curIdentityId,
      curIdentityData,
      isShowError,
      isListEmpty,
      IDENTITY_TYPE_MAP,

      onChange,
      refresh,
      onAddAuthorization,
    };
  },
});
